var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({attrs:{"size":"small"},on:{"click":function($event){return _vm.$emit('click')}}},'el-button',_vm.$attrs,false),[_vm._v("\n\t"+_vm._s(_vm.LocalizePopisostatni('Delete'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }